
export default {
	name: 'AppPage',
	data () {
		return {

		};
	},
	computed: {
		appFeatures ()
		{
			return [
				{ label: 'Trade Anytime, Anywhere',  desc: 'Enjoy the freedom to manage your crypto portfolio on the go.' },
				{ label: 'User-Friendly Interface',  desc: 'Navigate effortlessly with our intuitive design, perfect for both beginners and experienced traders.' },
				{ label: 'Real-Time Market Updates', desc: 'Stay informed with live price alerts and market trends to make timely decisions.' },
				{ label: 'Secure Transactions',      desc: 'Trade with confidence knowing your data and assets are protected with top-notch security features.' },
				{ label: 'Personalized Experience',  desc: 'Customize your dashboard and notifications to suit your trading style.' },
			];
		},
		appList ()
		{
			return [
				{ type: 'APK',   title: 'Download Android APK',     icon: require('@/assets/icons/app-apk.svg'),         link: 'https://enifex.com/apk/enifex.apk' },
				{ type: 'GPLAY', title: 'Install From Google Play', icon: require('@/assets/icons/app-google-play.svg'), link: 'https://play.google.com/store/apps/details?id=com.blockchaincommodities.enifex' },
				{ type: 'PWA',   title: 'Visit PWA Version',        icon: require('@/assets/icons/app-pwa.svg'),         link: 'https://m.enifex.com/' },
			];
		},
	},
}
